import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { object, omit } from 'underscore';
import { Search20Regular } from '@fluentui/react-icons';
import { Input, makeStyles, tokens } from '@fluentui/react-components';

const useStyles = makeStyles({
  filterItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS,
  },
});

const ExtraInputFilterComponent = (props) => {
  const {
    adQueryInput,
    searchParams,
    setSearchParams,
  } = props;
  const classes = useStyles();

  const [searchText, setSearchText] = useState(adQueryInput);

  const onInputChange = useCallback((ev, data) => {
    setSearchText(data.value);
  }, [setSearchText]);

  const onInputKeyDown = useCallback((ev) => {
    if (ev.key === 'Enter') {
      if (searchText !== '') {
        let newSearchParams = object([...searchParams]);
        newSearchParams.aq = searchText;
        newSearchParams = omit(newSearchParams, 'page');
        setSearchParams(newSearchParams);
      } else {
        setSearchParams({});
      }
    }
  }, [searchText, searchParams, setSearchParams]);

  useEffect(() => {
    setSearchText(adQueryInput);
  }, [adQueryInput]);

  return (
    <div className={classes.filterItem}>
      <Input
        placeholder="Ad content"
        type="text"
        contentBefore={<Search20Regular />}
        value={searchText}
        onChange={onInputChange}
        onKeyDown={onInputKeyDown}
      />
    </div>
  );
};

ExtraInputFilterComponent.propTypes = {
  adQueryInput: PropTypes.string,
  searchParams: PropTypes.shape({
    get: PropTypes.func,
  }).isRequired,
  setSearchParams: PropTypes.func.isRequired,
};

ExtraInputFilterComponent.defaultProps = {
  adQueryInput: '',
};

export const ExtraInputFilter = ExtraInputFilterComponent;
